// ============================================================================
// COIN CHANGE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'coin-change',
  name: 'Coin Change',
  category: 'Dynamic Programming',
  complexity: {
    time: 'O(N * M)',
    space: 'O(M)'
  },
  description: 'A dynamic programming algorithm that finds the minimum number of coins needed to make a given amount, or determines if it\'s impossible. It builds a DP table where dp[i] represents the minimum coins needed for amount i.'
};
